module.exports = __webpack_public_path__ + "static/media/facebook.b45696e8.svg";